module.exports = __webpack_public_path__ + "9743332b1996783a6078e5dd51ebc562.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./photo.jpg
 ** module id = 479
 ** module chunks = 0
 **/